module.exports = __webpack_public_path__ + "static/media/PhoneDevice.ac97c693.png";